export default "__VITE_ASSET__Bkz5kJ2t__"